const videoWrappers = document.querySelectorAll('.js-video');

videoWrappers.forEach((videoWrapper) => {
    const video = videoWrapper.querySelector('video');
    const controls = videoWrapper.querySelector('.js-video-controls');
    const play = videoWrapper.querySelector('.js-video-play');
    const stop = videoWrapper.querySelector('.js-video-stop');
    const fwd = videoWrapper.querySelector('.js-video-fwd');
    const rwd = videoWrapper.querySelector('.js-video-rwd');
    const toggleMute = videoWrapper.querySelector('.js-video-toggle-mute');
    const mute = toggleMute.querySelector('.js-mute');
    const unmute = toggleMute.querySelector('.js-unmute');
    const elapsedTime = videoWrapper.querySelector('.js-video-time');

    video.volume = 1;
    video.removeAttribute('controls');
    controls.classList.remove('ui-hidden');
    unmute.classList.add('ui-hidden');

    play.addEventListener('click', () => {
        video.play();
    });

    stop.addEventListener('click', () => {
        video.pause();
    });

    video.addEventListener('play', () => {
        play.classList.add('is-active');
        stop.classList.remove('is-active');
    });

    video.addEventListener('pause', () => {
        stop.classList.add('is-active');
        play.classList.remove('is-active');
    });

    video.addEventListener('ended', () => {
        stop.classList.add('is-active');
        play.classList.remove('is-active');
    });

    rwd.addEventListener('click', () => {
        if (video.currentTime <= 10) {
            video.currentTime = 0;
        } else {
            video.currentTime -= 10;
        }
        video.play();
    });

    fwd.addEventListener('click', () => {
        if (video.currentTime >= video.duration - 10) {
            video.currentTime = video.duration;
            video.stop();
        } else {
            video.currentTime += 10;
            video.play();
        }
    });

    video.addEventListener('timeupdate', () => {
        const minutes = Math.floor(video.currentTime / 60);
        const seconds = Math.floor(video.currentTime - minutes * 60);

        const minuteValue = minutes.toString().padStart(2, '0');
        const secondValue = seconds.toString().padStart(2, '0');

        const mediaTime = `${minuteValue}:${secondValue}`;
        elapsedTime.textContent = mediaTime;
    });

    video.addEventListener('volumechange', (event) => {
        if (video.volume == 0 || video.muted === true) {
            mute.classList.add('ui-hidden');
            unmute.classList.remove('ui-hidden');
        } else {
            unmute.classList.add('ui-hidden');
            mute.classList.remove('ui-hidden');
        }
    });

    toggleMute.addEventListener('click', () => {
        if (video.volume > 0 && !video.muted) {
            video.volume = 0;
            video.muted = true;
        } else {
            video.volume = 1;
            video.muted = false;
        }
    });
});
